export function chatUrl(accountPublicId: string, conversationId: string): string {
  return `/a/${encodeURIComponent(accountPublicId)}/c/${encodeURIComponent(conversationId)}`;
}

export function accountHomeUrl(accountPublicId: string): string {
  return `/a/${encodeURIComponent(accountPublicId)}`;
}

// Legacy URL parser — extracts conversation id from /chats/{id} so the redirect page knows what to look up.
export function parseLegacyChatUrl(pathname: string): { conversationId: string } | null {
  const m = pathname.match(/^\/chats\/([^\/?#]+)\/?$/);
  if (!m) return null;
  return { conversationId: decodeURIComponent(m[1]) };
}

// Parse /a/{publicId}/c/{id} pathnames (used in tests; client-side routing handled by Next.js segments).
export function parseChatUrl(pathname: string): { accountPublicId: string; conversationId: string } | null {
  const m = pathname.match(/^\/a\/([^\/]+)\/c\/([^\/?#]+)\/?$/);
  if (!m) return null;
  return {
    accountPublicId: decodeURIComponent(m[1]),
    conversationId: decodeURIComponent(m[2]),
  };
}

// Decides whether a legacy /chats/{id} URL should be upgraded to the new /a/{publicId}/c/{id} form.
// Returns the target URL or null if no redirect is appropriate yet (already on new route, data
// not loaded, or user not a member of the conversation's account).
export function legacyChatRedirectTarget(opts: {
  pathname: string | null | undefined;
  conversation: { id: string; account_id: string } | null;
  accounts: { id: string; public_id: string }[];
}): string | null {
  const { pathname, conversation, accounts } = opts;
  if (!pathname || !pathname.startsWith("/chats/")) return null;
  if (!conversation) return null;
  const acc = accounts.find((a) => a.id === conversation.account_id);
  if (!acc) return null;
  return chatUrl(acc.public_id, conversation.id);
}
